import React, { useState, useEffect } from "react";
import { useLoader } from "../../contexts/LoaderContext";
import logo from "../../assets/st-app-icon.svg";
import "./FullPageLoader.scss";

const FullPageLoader: React.FC = () => {
  const { isLoading, message } = useLoader();
  const [dots, setDots] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => {
        if (prev.length >= 3) return "";
        return prev + ".";
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  if (!isLoading) return null;

  return (
    <div className="page_loader">
      <div className="loader-container">
        <div className="image-block">
          <img
            style={{ width: "40px", height: "40px" }}
            src={logo}
            alt="logo"
            className="logo-image"
          />
        </div>
        <div className="loading-text min-w-[80px]">
          {message || "Loading"}
          {dots}
        </div>
        <div className="loading-bar">
          <div className="loading-progress"></div>
        </div>
      </div>
    </div>
  );
};

export default FullPageLoader;
